module.exports = __webpack_public_path__ + "static/pill-background-9d58e603a1bc3f7b263b03ce891665d3.jpeg";